import './detail-program.scss'
import React, { useEffect, useState } from 'react';
import { getMovieDataV2 } from '../../../shared/services/movie/movie-service';
import StarIcon from '@material-ui/icons/Star';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ImageGenerator from '../../../components/image-generator/image-generator';
import { Accordion, AccordionDetails, AccordionSummary, Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { getSeriesDataV2 } from '../../../shared/services/series/series-service';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ArrowForwardIos } from '@material-ui/icons';
import Loading from '../../../components/loading/item-loading/loading';
function BazaarDetailProgram (props) {
	const [movieData, setMovieData] = useState();
	const [loading,setLoading] = useState(true);
	const [expanded, setExpanded]  = useState(false);

	useEffect(() => {
		document.body.classList.add('body-bg');
		if (props.match.params.type === 'movies') {
			getMovieDataV2(props.match.params.id).then((res) => {
				if (res.data.code === 200) {
					setMovieData(res.data.data);
					setLoading(false)
				}
			})
		} else if (props.match.params.type === 'series') {
			getSeriesDataV2(props.match.params.id).then((res) => {
				if (res.data.code === 200) {
					setMovieData(res.data.data);
					setLoading(false)
				}
			})
		}
	}, [])

	const handleChange = (panel, index) => (event, isExpanded) => {
		// setSelectedSeason(index);
		setExpanded(isExpanded ? panel : false);
	};

	const renderSeriesData = () => {

		const seasons = Object.values(movieData?.seasons || {});

		return (
			<>
				<div className="seasons-box">
					<div style={{
						height: '100%',
						width: '100%',
					}}>

						{seasons.map((s, i) => {
							return <Accordion expanded={expanded === 'panel' + i}
											  onChange={handleChange('panel' + i, i)} key={i} style={{
								position: 'relative',
							}}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel1bh-content"
									id="panel1bh-header"
								>
									<p>فصل {i+1}</p>
								</AccordionSummary>
								<AccordionDetails>
									<div className="episode-box">
										{s.map((e, j) => {
											return <Link key={j} className="" to={`/player/${e.videoId}`}>
												<p className="qualities">قسمت {e.episodeNumber}</p>
											</Link>;
										})}
									</div>
								</AccordionDetails>
							</Accordion>;
						})}
					</div>

				</div>
			</>
		)
	}

	function firstVideoId() {
		const firstSeasonKey = Object.keys(movieData?.seasons || {})[0];
		const firstEpisode = movieData?.seasons[firstSeasonKey]?.[0];
		return  firstEpisode?.videoId;
	}
	function goBack() {
		window.history.back();
	}

	if (loading) {
		return <Loading/>;
	}


	const renderResult = () => {
		return (
			<>
				<div className="container cafebazaar">
					<div className="card-container">
						{<div className="goToHome">
							<button onClick={goBack}>
								<Icon component={ArrowForwardIos}/>
								بازگشت
							</button>
						</div>}
					</div>
					<div className="program-info card-container">
						<div className="program-poster">
							<ImageGenerator
								src={movieData?.baseDetails.image}
								isLazy={false}
								name={''} />
						</div>
						<div className="info">
							<div>
								<div className="">
									<h1 className="title">{movieData?.baseDetails.title}</h1>
									<h2 className="en-title">{movieData?.baseDetails.englishTitle}</h2>
								</div>
								<p>
									{movieData?.baseDetails.description}
								</p>
							</div>
							<div className="d-flex meta-data">
								<div className="rate">
									<div>
										<Icon component={StarIcon} />
										<span>{movieData?.metadata.imdb}</span>
									</div>
									<span>امتیاز</span>
								</div>
								<div className="views">
									<div>
										<Icon component={FavoriteIcon} />
										<span>{movieData?.programInteractions.likedPercent}</span>
									</div>
									<span>رضایت</span>
								</div>
							</div>
						</div>
						{movieData?.seasons ?

							<Link to={`/player/${firstVideoId()}`} className="play">
								<button className="primary">پخش (قسمت 1)</button>
							</Link>
						:
							<Link to={`/player/${movieData?.programInteractions.programId}`} className="play">
								<button className="primary">پخش</button>
							</Link>
						}
					</div>
					<div className="mobi-device card-container">
						<p>
							{movieData?.baseDetails.description}
						</p>
					</div>
					{
						movieData?.seasons && <div style={{padding: '.5rem'}}>
							{renderSeriesData()}
						</div>
					}
				</div>

			</>
		);
	}
	return (renderResult());
}

export default BazaarDetailProgram;